/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
    return JSON.parse(sessionStorage.getItem('btnGroup') || '[]').indexOf(key) !== -1 || false
}


// WEBPACK FOOTER //
// ./src/assets/js/isAlon.js